var React = require('react');

function Exclamation (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2.5","transform":"rotate(180 8 8)"},[React.createElement("circle",{"cx":"7","cy":"7","r":"7","key":0}),React.createElement("path",{"d":"M7 9.8V7m0-3v-.5","key":1})]));
}

Exclamation.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = Exclamation;

Exclamation.default = Exclamation;
